var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{ref:"modalCustomerData",attrs:{"size":"lg","title":_vm.modalData.title,"header-bg-variant":_vm.headerBgVariant,"header-text-variant":_vm.headerTextVariant},on:{"hidden":function($event){return _vm.$emit('closeModal')},"ok":_vm.handleOk}},[_c('FormCustomer',{attrs:{"selectedPlan":_vm.selectedPlan}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }